import { IsInt, Min, IsEnum, IsNotEmpty, IsOptional, IsNumber } from 'class-validator';
import { MembershipDto } from './membership.dto';
import { MembershipTierFrequencyEnum } from '../../enums';

export class MembershipTierDto {
	public id: string;
	public membershipId: string;
	public frequency: MembershipTierFrequencyEnum;
	public amount: number; // in cents
	public createdAt: Date;
	public updatedAt: Date;
	public deletedAt?: Date;
	public signUpFee?: number | null; // in cents
	public startDate?: Date | null;
	public endDate?: Date | null;

	public membership?: MembershipDto;
}

export class UpsertMembershipTierDto {
	@IsInt()
	@IsNotEmpty()
	@Min(0)
	public amount: number;

	@IsEnum(MembershipTierFrequencyEnum)
	@IsNotEmpty()
	public frequency: MembershipTierFrequencyEnum;

	@IsNumber()
	@IsInt()
	@Min(0)
	@IsOptional()
	public signUpFee?: number | null;

	@IsOptional()
	public startDate?: Date | null;

	@IsOptional()
	public endDate?: Date | null;
}
